import * as m from "../../es2015/plugins/bullets";
window.am4plugins_bullets = m;


//////////////////
// WEBPACK FOOTER
// ./plugins/bullets.js
// module id = null
// module chunks = 